<template>
  <div class="main text-left">
    <div class="form-floating mb-3">
      <input type="email" class="form-control" id="floatingUsername" v-model="input.username" :maxlength="50"
        :placeholder="this.$t('lang.dict.email')">
      <label for="floatingUsername">{{ this.$t('lang.dict.email') }}</label>
    </div>
    <div class="form-floating mb-3">
      <input type="password" class="form-control" id="floatingPassword" v-model="input.password" :maxlength="50"
        :placeholder="this.$t('lang.dict.password')">
      <label for="floatingPassword">{{ this.$t('lang.dict.password') }}</label>
    </div>

    <button type="submit" class="btn btn-info" v-on:click="login()">{{ this.$t('lang.toolbar.Login')
      }}</button>
    <p>
      <br>
      <span class="fs-6 text-muted">{{ this.$t('lang.msg.toRegister') }}
        <span class="btn btn-link" v-on:click="toRegister()">{{ this.$t('lang.toolbar.Register') }}</span></span>
      <br>
      <span class="fs-6 text-muted">{{ this.$t('lang.msg.toRecovery') }} <span class="btn  btn-link"
          v-on:click="toRecovery()">{{ this.$t('lang.toolbar.Recovery') }}</span></span>
    </p>
  </div>
</template>
<script>
import sx from '../../utils/core.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        username: '',
        password: ''
      },
      searchOpt: {
        LoginMode: 'Client'
      }
    }
  },
  mounted() {
    this.input.username = localStorage.getItem('username')
    this.input.password = sx.decrypt(localStorage.getItem('password'), '')
  },
  methods: {
    toRegister() {
      this.$router.replace({ name: 'Register' })
        .catch(error => {
          console.info(error.message);
        })
    },
    toRecovery() {
      this.$router.replace({ name: 'Recovery' })
        .catch(error => {
          console.info(error.message);
        })
    },
    login() {
      const that = this
      if (that.input.username != '' && that.input.password != '') {
        var params = {
          username: that.input.username,
          password: that.input.password,
          options: JSON.stringify(that.searchOpt),
          token: ''
        }
        const mymodal = sx.showWaiting()
        sx.request(
          that.$store.state.baseurl + '/app/authhelper/login',
          params,
          function (result) {
            if (result.status == 'ok') {
              sx.toastSuccess(that.$t('lang.info.succeedToLogin'))
              var d = result.data
              localStorage.setItem('token', d.token)
              localStorage.setItem('authenticated', true)
              localStorage.setItem('username', that.input.username)
              localStorage.setItem('password', sx.encrypt(that.input.password, ''))
              localStorage.setItem('loginurl', '/app/authhelper/login')
              localStorage.setItem('userinfo', JSON.stringify(d.userinfo))
              that.$store.state.authenticated = true
              that.$store.state.userinfo = d.userinfo;
              that.$router.replace({ name: 'Console' })
            } else if (result.status == 'err') {
              sx.toastError(that.$t('lang.error.failedLogin'))
              console.log('wrong password!')
            } else {
              sx.toastError(that.$t('lang.error.notExistAccount'))
              console.log('Account not exist!')
            }
          },
          function (result) {
            console.log(result)
          }
        )
        sx.hideWaiting(mymodal)
      } else {
        sx.toastError(that.$t('lang.error.required', { str: that.$t('lang.dict.email') + "," + that.$t('lang.dict.password') }));
        console.log('required!')
      }
    }
  }
}
</script>
